<template>
  <result-half-loan-loading />
</template>

<script>
import ResultHalfLoanLoading from '@/components/resultHalfLoanLoading'

export default {
  name: 'ResultHalfLoanLoadingPage',
  components: {
    ResultHalfLoanLoading,
  },
}
</script>
